var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgAppleItunesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 602 602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -450.362)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 342.206,
    y1: 289.775,
    x2: 342.79,
    y2: 880.123,
    gradientTransform: "matrix(1 0 0 -1 -41.5 1338.724)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bb5bfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb82d6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M138.684 451.362h324.631c76.277 0 137.685 61.407 137.685 137.684v324.631c0 76.277-61.407 137.685-137.685 137.685H138.684C62.407 1051.362 1 989.955 1 913.678V589.046c0-76.277 61.407-137.684 137.684-137.684z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M300.462 487.623c-142.359 0-257.758 115.399-257.758 257.758 0 142.36 115.399 257.759 257.758 257.759 142.36 0 257.759-115.398 257.759-257.759 0-142.359-115.399-257.758-257.759-257.758zm0 28.449c126.63 0 229.311 102.681 229.311 229.31 0 126.63-102.681 229.311-229.311 229.311-126.629 0-229.095-102.681-229.095-229.311 0-126.629 102.466-229.31 229.095-229.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M407.873 573.447l-178.746 48.334h-.207v72.706h.207v130c-7.82-4.706-17.407-7.5-27.707-7.5-26.533 0-47.913 18.427-47.913 41.04 0 22.62 21.386 40.834 47.913 40.834s49.073-18.233 48.127-40.833l-.487-11.6-1.18-157.154 141.247-38.127v143.54c-8.247-5.686-18.774-9.166-30.207-9.166-26.533 0-47.92 18.427-47.92 41.04 0 22.62 21.387 40.833 47.92 40.833s48.833-18.213 48.833-40.833c0-.213.007-.413 0-.627l.127-179.793V573.447h-.007z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAppleItunesIcon);
export default __webpack_public_path__ + "static/media/img-apple-itunes-icon.3f7fbb0bec5806a83bef47a946f3a637.svg";
export { ForwardRef as ReactComponent };